import { matchTrackKind, selectableOptions, type Track } from '@anytracker/core'

/**
 * A short badge describing what a track measures.
 *
 * `matchTrackKind` rather than a `switch`, so a fourth value type added to core
 * becomes a compile error here rather than a track quietly rendering with a
 * blank badge.
 */
export function kindLabel(track: Track): string {
  return matchTrackKind(track.kind, {
    numeric: (kind) => `${String(kind.min)}–${String(kind.max)}`,
    boolean: () => 'Yes / no',
    marker: () => 'Marker',
    multi: () => 'Multi-select',
    enum: (kind) => {
      const count = selectableOptions(kind).length
      return `${String(count)} ${kind.ordered ? 'ranked' : 'options'}`
    },
  })
}

/**
 * What a track records, as a phrase for the line under its name.
 *
 * Longer than `kindLabel`, which is the badge: this one says what the value
 * is ("Scale 1 to 10", "One of 5, in order"), the badge says it in a glance.
 */
export function kindDescription(track: Track): string {
  return matchTrackKind(track.kind, {
    numeric: (kind) =>
      track.unit === undefined
        ? `Scale ${String(kind.min)} to ${String(kind.max)}`
        : `Number, in ${track.unit}`,
    boolean: () => 'Yes or no',
    marker: () => 'Marker, notes that it happened',
    multi: (kind) => `Several of ${String(selectableOptions(kind).length)}`,
    enum: (kind) =>
      `One of ${String(selectableOptions(kind).length)}${kind.ordered ? ', in order' : ''}`,
  })
}
